import React from 'react';
import { Modal } from 'react-bootstrap';
import { connect } from 'react-redux';
import {
  hideActivityLogDetail,
  hideModalActivityLog,
  showActivityLogDetail,
  setSelectedActivityLog,
  onLoadActivityLogs,
} from 'actions/setting/bankAccount';
import moment from 'moment';
import * as clevertapSettingsBankAccounts from 'clevertap/settings/bankAccounts';
import InfiniteScroll from 'react-infinite-scroller';
import NoDataAndLoading from 'components/NoDataAndLoading';
import { isEmpty } from 'lodash';
import styles from './style.css';

class ActivityLogModal extends React.Component {
  render() {
    const {
      activityLogs,
      selectedActivityLog,
      showActivityLogDetail,
      showModalActivityLog,
      showLoadingSpinnerModal,
    } = this.props;

    return (
      <Modal
        show={showModalActivityLog}
        className={`${styles.modal}`}
        dialogClassName={`modal-dialog ${styles['modal-dialog']} ${
          styles['modal-activity-log']
        }`}
      >
        <Modal.Header>
          <Modal.Title>
            <span>Activity Log</span>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {showActivityLogDetail ? (
            <div className={`${styles['table-wrapper-activity-log-detail']}`}>
              <div className={`${styles['table-content-wrapper']}`}>
                <table className={styles['table-content']}>
                  <tbody>
                    <tr className={`${styles['table-row-head']}`}>
                      <td>
                        <strong>Basic Information</strong>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p>
                          <span className={`${styles['text-light-grey']}`}>
                            Time
                          </span>
                          <span className="pull-right">
                            {this._renderDate(selectedActivityLog.created_at)},{' '}
                            {this._renderTime(selectedActivityLog.created_at)}
                          </span>
                        </p>
                        <p>
                          <span className={`${styles['text-light-grey']}`}>
                            Updated By
                          </span>
                          <span className="pull-right">
                            {selectedActivityLog.user_name}
                            {!isEmpty(selectedActivityLog.user_email)
                              ? ` - ${selectedActivityLog.user_email}`
                              : ''}
                          </span>
                        </p>
                        <p>
                          <span className={`${styles['text-light-grey']}`}>
                            Bank
                          </span>
                          <span className="pull-right">
                            {selectedActivityLog.bank_name} -{' '}
                            {selectedActivityLog.account_holder_number}
                          </span>
                        </p>
                        <p>
                          <span className={`${styles['text-light-grey']}`}>
                            Action
                          </span>
                          <span className="pull-right">
                            {this._renderAction(selectedActivityLog.action)}
                          </span>
                        </p>
                      </td>
                    </tr>

                    <tr className={`${styles['table-row-head']}`}>
                      <td>
                        <strong>Action Details</strong>
                      </td>
                    </tr>

                    {selectedActivityLog.action === 'UPDATE' && (
                      <tr>
                        <td>
                          <p>
                            <strong>Updated Bank Name</strong>
                          </p>
                          {selectedActivityLog.bank_name !==
                          selectedActivityLog.bank_name_before ? (
                            <div>
                              <p>
                                <span
                                  className={`${styles['text-light-grey']}`}
                                >
                                  To
                                </span>
                                <span className="pull-right">
                                  {selectedActivityLog.bank_name}
                                </span>
                              </p>
                              <p>
                                <span
                                  className={`${styles['text-light-grey']}`}
                                >
                                  From
                                </span>
                                <span className="pull-right">
                                  {selectedActivityLog.bank_name_before}
                                </span>
                              </p>
                            </div>
                          ) : (
                            <p className={`${styles['text-light-grey']}`}>
                              No updates
                            </p>
                          )}
                        </td>
                      </tr>
                    )}
                    {selectedActivityLog.action === 'UPDATE' && (
                      <tr>
                        <td>
                          <p>
                            <strong>Updated Account Number</strong>
                          </p>
                          {selectedActivityLog.account_holder_number !==
                          selectedActivityLog.account_holder_number_before ? (
                            <div>
                              <p>
                                <span
                                  className={`${styles['text-light-grey']}`}
                                >
                                  To
                                </span>
                                <span className="pull-right">
                                  {selectedActivityLog.account_holder_number}
                                </span>
                              </p>
                              <p>
                                <span
                                  className={`${styles['text-light-grey']}`}
                                >
                                  From
                                </span>
                                <span className="pull-right">
                                  {
                                    selectedActivityLog.account_holder_number_before
                                  }
                                </span>
                              </p>
                            </div>
                          ) : (
                            <p className={`${styles['text-light-grey']}`}>
                              No updates
                            </p>
                          )}
                        </td>
                      </tr>
                    )}
                    {selectedActivityLog.action === 'UPDATE' && (
                      <tr>
                        <td>
                          <p>
                            <strong>Updated Account Holder</strong>
                          </p>
                          {selectedActivityLog.account_holder_name !==
                          selectedActivityLog.account_holder_name_before ? (
                            <div>
                              <p>
                                <span
                                  className={`${styles['text-light-grey']}`}
                                >
                                  To
                                </span>
                                <span className="pull-right">
                                  {selectedActivityLog.account_holder_name}
                                </span>
                              </p>
                              <p>
                                <span
                                  className={`${styles['text-light-grey']}`}
                                >
                                  From
                                </span>
                                <span className="pull-right">
                                  {
                                    selectedActivityLog.account_holder_name_before
                                  }
                                </span>
                              </p>
                            </div>
                          ) : (
                            <p className={`${styles['text-light-grey']}`}>
                              No updates
                            </p>
                          )}
                        </td>
                      </tr>
                    )}
                    <tr>
                      <td>
                        <p>
                          <strong>
                            {selectedActivityLog.action === 'UPDATE'
                              ? 'Newly'
                              : ''}{' '}
                            Assigned Outlets
                          </strong>
                        </p>
                        {selectedActivityLog.new_outlet_names.length === 0 && (
                          <p className={`${styles['text-light-grey']}`}>
                            {selectedActivityLog.action === 'UPDATE'
                              ? 'No updates'
                              : 'No outlet assigned'}
                          </p>
                        )}
                        {selectedActivityLog.new_outlet_names.map(
                          (newOutletName, index) => {
                            return <p key={index}>{newOutletName}</p>;
                          }
                        )}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          ) : (
            <div className={`${styles['table-wrapper-activity-log']}`}>
              <table className={`${styles['table-header']}`}>
                <thead>
                  <tr>
                    <th width="13%">Time</th>
                    <th width="26%">Updated By</th>
                    <th width="22%">Bank</th>
                    <th width="14%">Action</th>
                    <th width="20%">Action Details</th>
                    <th width="5%" />
                  </tr>
                </thead>
              </table>

              <NoDataAndLoading
                showLoadingSpinner={showLoadingSpinnerModal}
                noDataToDisplay={activityLogs.length === 0}
                title="No Data To Display"
                heightClass={`${styles['table-no-data-activity-log']}`}
              />
              <div className={`${styles['table-content-wrapper']}`}>
                {activityLogs.length > 0 && (
                  <InfiniteScroll
                    pageStart={1}
                    loadMore={this._onReachBottom}
                    hasMore={this._hasMore()}
                    useWindow={false}
                    threshold={10}
                    initialLoad={false}
                  >
                    <table className={styles['table-content']}>
                      <tbody>
                        {activityLogs.map((activityLog, i) => {
                          return (
                            <tr key={i}>
                              <td width="13%">
                                {this._renderDate(activityLog.created_at)}
                                <br />
                                {this._renderTime(activityLog.created_at)}
                              </td>
                              <td width="26%">
                                {activityLog.user_name}
                                <br />
                                {activityLog.user_email}
                              </td>
                              <td width="22%">
                                {activityLog.bank_name}
                                <br />
                                {activityLog.account_holder_number}
                              </td>
                              <td width="14%">
                                {this._renderAction(activityLog.action)}
                              </td>
                              <td width="20%">
                                {this._renderActionDetails(activityLog)}
                              </td>
                              <td width="5%">
                                {['ADD', 'UPDATE'].includes(
                                  activityLog.action
                                ) && (
                                  <button
                                    className={`btn ${
                                      styles['btn-activity-detail']
                                    }`}
                                    onClick={() =>
                                      this._onClickActivityLogDetail(
                                        activityLog
                                      )
                                    }
                                  >
                                    <i className="glyphicon glyphicon-chevron-right" />
                                  </button>
                                )}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </InfiniteScroll>
                )}
              </div>
            </div>
          )}
        </Modal.Body>

        <Modal.Footer>
          {showActivityLogDetail ? (
            <button
              className={`btn mr-10px ${styles['btn-outline-dark']} ${
                styles['btn-large']
              }`}
              type="button"
              onClick={this._onClickBack}
            >
              Back
            </button>
          ) : (
            <button
              className={`btn mr-10px ${styles['btn-outline-dark']} ${
                styles['btn-large']
              }`}
              type="button"
              onClick={this._onClickClose}
            >
              Close
            </button>
          )}
        </Modal.Footer>
      </Modal>
    );
  }

  _renderAction = action => {
    switch (action) {
      case 'ADD':
        return (
          <span
            className={`${styles.label} ${styles['label-action']} ${
              styles['bg-success']
            }`}
          >
            Add Bank
          </span>
        );
      case 'UPDATE':
        return (
          <span className={`${styles.label} ${styles['label-action']}`}>
            Update Bank
          </span>
        );
      case 'DELETE':
        return (
          <span
            className={`${styles.label} ${styles['label-action']} ${
              styles['bg-danger']
            }`}
          >
            Delete Bank
          </span>
        );
      default:
        return '';
    }
  };

  _renderActionDetails = activityLog => {
    const outletsAssignedText =
      activityLog.new_outlet_names.length > 0
        ? `${activityLog.new_outlet_names.length} Outlets Assigned`
        : '';

    switch (activityLog.action) {
      case 'ADD':
        return (
          <span>
            New Bank Added <br /> {outletsAssignedText}
          </span>
        );
      case 'UPDATE':
        if (
          activityLog.bank_name !== activityLog.bank_name_before ||
          activityLog.account_holder_number !==
            activityLog.account_holder_number_before ||
          activityLog.account_holder_name !==
            activityLog.account_holder_name_before
        ) {
          return (
            <span>
              Bank Info Updated <br /> {outletsAssignedText}
            </span>
          );
        }
        return outletsAssignedText;

      case 'DELETE':
        return 'Bank Deleted';
      default:
        return '';
    }
  };

  _renderDate = createdAt => {
    return moment(createdAt).format('DD/MM/YYYY');
  };

  _renderTime = createdAt => {
    return moment(createdAt).format('HH:mm');
  };

  _onClickActivityLogDetail = activityLog => {
    this.props.dispatch(setSelectedActivityLog(activityLog));
    this.props.dispatch(showActivityLogDetail());
    clevertapSettingsBankAccounts.accountSettingsBankAccountActivityLogDetails();
  };

  _onClickBack = () => {
    this.props.dispatch(hideActivityLogDetail());
  };

  _onClickClose = () => {
    this.props.dispatch(hideModalActivityLog());
  };

  _onReachBottom = () => {
    const { activityLogs, hasMoreActivityLogs } = this.props;
    if (hasMoreActivityLogs) {
      this.props.dispatch(onLoadActivityLogs(activityLogs));
    }
  };

  _hasMore = () => {
    return this.props.hasMoreActivityLogs;
  };
}

function mapStateToProps(state) {
  const {
    activityLogs,
    hasMoreActivityLogs,
    selectedActivityLog,
    showActivityLogDetail,
    showModalActivityLog,
    showLoadingSpinnerModal,
  } = state.setting.bankAccount;

  return {
    activityLogs,
    hasMoreActivityLogs,
    selectedActivityLog,
    showActivityLogDetail,
    showModalActivityLog,
    showLoadingSpinnerModal,
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ActivityLogModal);
